import React from 'react';
import cn from 'classnames';
import InfoIcon from '@mui/icons-material/Info';
import {
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  Fade,
  Tooltip,
  Zoom,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { Text } from '../../text';
import styles from '../index.module.css';

export const ContentBoxTitle = ({ title, description, failedToGenerate }) => (
  <div className={styles.contentBoxTitleContainer}>
    <div className={styles.textWrapper}>
    <Text.SectionTitle className={styles.contentBoxTitle}>{title}</Text.SectionTitle>
     {failedToGenerate && (
  <Tooltip title="Failed to generate the thumbnail">
    <InfoIcon fill="red" style={{ fill: 'red' }} fontSize="small" />
  </Tooltip>
)}
    </div>
    {description && <p style={{ color: failedToGenerate && '#5aa5ef' }} className={styles.contentBoxDescription}>{description}</p>}
  </div>
);

export const ContentBox = ({ children, className, flex }) => (
  <section className={cn({ [styles.contentBoxContainer]: true, [className]: className })}>
    <div className={cn({ [styles.contentBox]: true, [styles.flex]: flex })}>
      {children}
    </div>
  </section>
);

export const ContentBoxSection = ({ children, className, title, description, failedToGenerate }) => (
  <section className={cn({ [styles.contentBoxSection]: true, [className]: className })}>
    <ContentBoxTitle title={title} description={description} failedToGenerate={failedToGenerate} />
    <div className={styles.contentBoxSectionWrapper}>
      {children}
    </div>
  </section>
);
